import Art from "../../components/home/Art";
import Banner from "../../components/home/Banner";
import Contact from "../../components/home/Contact";
import Explorer from "../../components/home/Explorer";
import Master from "../../components/home/Master";
import Product from "../../components/home/Product";
import Special from "../../components/home/Special";

const MainPage = () => {
  return (
    <div className=" relative w-full h-full">
      <Banner />
      <Explorer />
      <Special />
      {/* <NewArrival /> */}
      <Product />
      <Master />
      <Art />
      <Contact />
    </div>
  );
};

export default MainPage;
